// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__DKCQs","actions":"GroupTable_actions__2JlAG","deleteModalFooter":"GroupTable_deleteModalFooter__2VjEd"};